import { useForm } from "react-hook-form";
import ControllerSelectForUserCars from "../../SharedComponents/formComponents/uniqueFormComponents/ControllerSelectForUserCars";
import { FontEnum } from "../../SharedComponents/utils/enums/FontEnum";
import { mockedCars } from "../utils/staticData/mockedCars";
import { useEffect, useState } from "react";
import ControllerTextInput from "../../SharedComponents/formComponents/baseFormComponents/ControllerTextInput";
import ControllerCheckbox from "../../SharedComponents/formComponents/baseFormComponents/ControllerCheckbox";
import ControllerTextArea from "../../SharedComponents/formComponents/baseFormComponents/ControllerTextArea";
import BaseButton from "../../SharedComponents/components/Buttons/BaseButton";
import { ButtonVariantEnum } from "../../SharedComponents/utils/enums/ButtonVariantEnum";
import PlusIconSVG from "../../SharedComponents/assets/icons/svg/PlusIconSVG";
import RightArrowIconSVG from "../../SharedComponents/assets/icons/svg/RightArrowIconSVG";
import ConfirmOrderPartModal from "../components/Modals/ConfirmOrderPartModal";
import { orderPartFormValidator } from "../utils/formValidators/OrderPartFormValidator";
import { useDispatch, useSelector } from "react-redux";
import { getAddresses } from "../reduxStore/entities/address";
import { getCars } from "../reduxStore/entities/userCars";
import { getUserObject } from "../../../utils/getUserObject";
import AddImagesModal from "../../SharedComponents/components/Modals/AddImagesModal";
import BaseActionText from "../../SharedComponents/components/ActionText/BaseActionText";
import CloseModalIconSVG from "../../SharedComponents/assets/icons/svg/CloseModalIconSVG";
import { getSrcUrlFromFile } from "../../SharedComponents/utils/helpers/getSrcUrlFromFile";

const OrderPartForm = ({
    setSelectedForm
}) => {
    const userId = getUserObject()?.userid;

    const dispatch = useDispatch();
    const userCars = useSelector((state) => state.userCars.cars || []);
    const address = useSelector((state) => state.addresses?.addresses[0]?.address_id);

    useEffect(() => {
        dispatch(getAddresses());
        dispatch(getCars());
    }, [dispatch]);

    const [selectedCar, setSelectedCar] = useState(null);

    const [isFormValid, setIsFormValid] = useState(false);
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [imagesModalOpen, setImagesModalOpen] = useState(false);

    const [driversLicenceImage, setDriversLicenceImage] = useState(null);
    const [selectedImages, setSelectedImages] = useState([]);

    const methods = useForm();
    const { control, getValues, setValue, watch } = methods;

    const values = watch();

    useEffect(() => {
        const isFormStateValid = orderPartFormValidator(values);
        setIsFormValid(isFormStateValid);
    }, [values]);

    useEffect(() => {
        const length = selectedImages?.length;

        if (length) {
            if (length > 3) {
                alert('Broj slika ne sme biti veci od 3');
                setSelectedImages((oldVal) => [...oldVal].slice(0, 3));
                return;
            }

            setImagesModalOpen(true);
        }
    }, [selectedImages]);

    const handleImageUpload = (newFiles) => {
        setSelectedImages((prev) => {
            const newUniqueFiles = newFiles.filter(
                (newFile) => !prev.some((existing) => existing.name === newFile.name)
            );
            return [...prev, ...newUniqueFiles];
        });
    };

    const checkForAtLeastOneSelectedPartState = () => {
        const newPartSelected = getValues('isWantingNewPart');
        const usedPartSelected = getValues('isWantingUsedPart');
        const nullCondition = (!newPartSelected && !usedPartSelected);

        if (nullCondition) {
            setValue('isWantingNewPart', true);
            setValue('isWantingUsedPart', true);
        }
    };

    const GetUnSelectedDriversLicenceImageStack = () => {
        return (
            <div style={styles.vinInputContainer}>
                <ControllerTextInput
                    control={control}
                    name={'vinNumber'}
                    defaultValue={null}
                    placeholder={"Broj šasije"}
                    styleForInput={styles.inputBlack}
                />

                <p style={styles.baseStyleText}>ili</p>

                <BaseActionText
                    onClick={setDriversLicenceImage}
                    text={"Dodajte sliku saobracajne dozvole"}
                    type={"file"}
                />
            </div>
        );
    };

    const GetSelectedDriversLicecnceImageStack = () => {
        return (
            <div style={styles.vinInputContainer}>
                <div style={styles.driversLicenceImageContainer}>
                    <img
                        src={getSrcUrlFromFile(driversLicenceImage)}
                        style={styles.diversLicenceImage}
                    />
                </div>

                <div onClick={() => setDriversLicenceImage(null)} style={styles.clickable}>
                    <CloseModalIconSVG />
                </div>
            </div>
        );
    };

    return (
        <>
            {imagesModalOpen && (
                <AddImagesModal
                    open={imagesModalOpen}
                    setOpen={setImagesModalOpen}
                    selectedImages={selectedImages}
                    apiHandler={async () => { }}
                />
            )}

            {confirmModalOpen && (
                <ConfirmOrderPartModal
                    open={confirmModalOpen}
                    setOpen={setConfirmModalOpen}
                    getValues={getValues}
                    selectedCar={selectedCar}
                    selectedImages={selectedImages}
                    address={address}
                />
            )}

            <div style={styles.mainContainer}>
                <p style={styles.title}>Izaberi automobil za koji trazis deo</p>

                <ControllerSelectForUserCars
                    control={control}
                    name={"carId"}
                    options={userCars}
                    externalOnChange={setSelectedCar}
                    setSelectedForm={setSelectedForm}
                />

                {selectedCar && (
                    <div style={styles.marginTop20}>
                        {driversLicenceImage
                            ? GetSelectedDriversLicecnceImageStack()
                            : GetUnSelectedDriversLicenceImageStack()
                        }

                        <p style={styles.baseStyleText}>
                            Omogucava pronalazak tacnog dela
                        </p>

                        <div style={styles.marginTop40}>
                            <ControllerCheckbox
                                control={control}
                                name={"isPark"}
                                labelText={"Parkirajte vozilo u garažu za lakšu pretragu delova"}
                            />
                        </div>

                        <div style={styles.partDescriptionContainer}>
                            <p style={styles.title}>Opis dela koji se trazi</p>

                            <ControllerTextInput
                                control={control}
                                name={"partDescrtiption"}
                                placeholder={"Opis dela"}
                                width={320}
                                styleForInput={styles.inputBlack}
                            />

                            <ControllerTextArea
                                control={control}
                                name={"detailedPartDescription"}
                                placeholder={"Detaljniji opis dela (ukoliko je potrebno)"}
                                width={320}
                                height={260}
                            />
                        </div>

                        <div style={styles.partDateContainer}>
                            <ControllerCheckbox
                                control={control}
                                name={"isWantingNewPart"}
                                labelText={"Trazim nov deo"}
                                defaultValue={true}
                                onChange={() => checkForAtLeastOneSelectedPartState()}
                            />

                            <ControllerCheckbox
                                control={control}
                                name={"isWantingUsedPart"}
                                labelText={"Trazim polovan deo"}
                                defaultValue={true}
                                onChange={() => checkForAtLeastOneSelectedPartState()}
                            />
                        </div>

                        <div style={styles.addImageContainer}>
                            <p style={styles.title}>Slike</p>

                            <div style={styles.imageUploadRow}>
                                <BaseButton
                                    onClick={handleImageUpload}
                                    type={"file"}
                                    variant={ButtonVariantEnum.WHITE}
                                    text={"Dodaj slike"}
                                    IconComponent={PlusIconSVG}
                                />
                                <p>Dodavanjem slika dela smanjujes rizik da dobijes pogresan deo</p>
                            </div>

                            <BaseButton
                                onClick={() => setConfirmModalOpen(true)}
                                variant={ButtonVariantEnum.BLACK}
                                text={"Postavi zahtev za deo"}
                                IconComponent={RightArrowIconSVG}
                                disabled={!isFormValid}
                                disableMessage={"Popunite obavezna polja"}
                            />
                        </div>
                    </div>
                )}
            </div>
        </>
    )
};

export default OrderPartForm;

const styles = {
    mainContainer: {
        marginTop: 30,
    },
    vinInputContainer: {
        display: "flex",
        alignItems: "center",
        gap: 6
    },
    driversLicenceImageContainer: {
        width: 60,
        height: 60,
        overflow: 'hidden'
    },
    diversLicenceImage: {
        objectFit: 'cover',
        width: "100%",
        height: "100%",
        borderRadius: 4
    },
    clickable: {
        cursor: 'pointer'
    },
    title: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "24px",
        fontWeight: 600,
        color: "#000000"
    },
    baseStyleText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "#000000de"
    },
    addTraficLicenceText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "#5B21B6"
    },
    partDescriptionContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        marginTop: 40
    },
    partDateContainer: {
        display: "flex",
        gap: 40,
        marginTop: 40
    },
    addImageContainer: {
        marginTop: 40,
        display: 'flex',
        flexDirection: 'column',
        gap: 30
    },
    addImageExplainerText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "#000000de"
    },
    marginTop20: {
        marginTop: 20
    },
    marginTop40: {
        marginTop: 40
    },
    imageUploadRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 10
    },
    inputBlack: {
        color: 'black'
    }
};
